import { render, staticRenderFns } from "./UserTypeForm.vue?vue&type=template&id=46bcc72d&"
import script from "./UserTypeForm.vue?vue&type=script&lang=js&"
export * from "./UserTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./UserTypeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports